import { render, staticRenderFns } from "./ModalDeleteOption.vue?vue&type=template&id=38e1467b"
import script from "./ModalDeleteOption.vue?vue&type=script&lang=js"
export * from "./ModalDeleteOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports